import Employees from '../models/Employees';

export default function isSuperAdmin(employee: Employees): boolean {
  return employee.employeeId === '77' || employee.employeeId === '9999';
}
